import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Grid  from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import {Form, Formik} from 'formik';
import * as yup from 'yup';
import Box from '@mui/material/Box';
import clsx from 'clsx';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { MyTextField, useStyles } from '../../Categories/AddCategory';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { AppState } from '../../../../store';
import jwtAxios from '../../../../services/axiosInstance/ApiConfig';
import { showSuccessMessage } from '../../../../common/Toaster';
import { onGetAllCategories, onGetAllSubCategories } from '../../../../store/actions/Category';
import InputLabel from '@mui/material/InputLabel';

const validationSchema = yup.object({
  sub_category: yup
	.string()
	.required('Please enter sub category name!')
});

interface AddSubCategoryProps {
	setOpen: (open: boolean) => void;
}

interface AddSubCategoryState {
	selectedCategory: any;
    sub_category: string;
}

const AddSubCategory = (props: AddSubCategoryProps) => {
	const dispatch = useDispatch()
	const {categories} = useSelector<AppState, AppState['categories']>(
        ({categories}) => categories,
    );
	const [values, setState] = useState<AddSubCategoryState>({
		selectedCategory: '',
        sub_category: ''
	})
  	const classes: any = useStyles(props);

	useEffect(() => {
		if(categories && categories.length > 0) {
			return 
		} else {
			dispatch(onGetAllCategories())
		}
	}, [dispatch, categories])

	const submitHandler = (data: AddSubCategoryState, setSubmitting: any) => {
		setSubmitting(true);
		const sub_cat_obj: any = categories.find((cat: any) => cat.name === values.selectedCategory)
		const body = { name: data.sub_category, category_id: sub_cat_obj._id }
		jwtAxios.post('/subcategory/add-subcategory', body)
		.then(response => {
			showSuccessMessage(response.data.msg)
			dispatch(onGetAllSubCategories())
		})
		props.setOpen(false)
		setSubmitting(false);
	}

    const handleChange = (event: SelectChangeEvent) => {
        setState({...values, selectedCategory: event.target.value as any});
    };

  	return (
	  <Box className={classes.formContainer}>
		<Box component="h4">Add New Sub Category </Box>
		<Grid container display="flex" flexDirection="column">
			<Grid item>
				<Paper className={classes.paper}>
					<Box flex={1} display='flex' p={2} flexDirection='column'>
						<Formik
							validateOnChange={true}
							initialValues={{...values}}
							validationSchema={validationSchema}
							onSubmit={(data, {setSubmitting}) => submitHandler(data, setSubmitting)}>
							{({isSubmitting}) => (
							<Form noValidate autoComplete="off">
                                <Box mb={{xs: 3, xl: 5}}>
                                    <FormControl fullWidth>
										<InputLabel id="category-list-label">Choose category</InputLabel>
										<Select
                                            labelId="category-list-label"
                                            id="category-list"
											name="category"
											label="Select Category"
											variant="outlined"
                                            value={values.selectedCategory}
                                            onChange={handleChange}
                                        >
                                            {categories && categories.length > 0 && categories.map((category: any) => {
                                                return <MenuItem key={category._id} value={category.name}>{category.name}</MenuItem>
                                            })}
                                        </Select>
                                    </FormControl>
                                </Box>
								<Box mb={{xs: 3, xl: 5}}>
									<MyTextField
										required
										id="standard-helperText"
										placeholder='sub category'
										name='sub_category'
										label='Sub category'
										variant='outlined'
									/>
								</Box>
								<Box
									mb={3}
									display='flex'
									flexDirection={{xs: 'column', sm: 'row'}}
									justifyContent={{sm: 'flex-end'}}>
									<Button
										color="secondary"
										variant="outlined"
										className={clsx(classes.signInButton)}
										onClick={() => props.setOpen(false)}
									>
										Cancel
									</Button>
									<Button
                                        color="primary"
										variant="outlined"
										type="submit"
										sx={{ml: 1}}
										disabled={isSubmitting}
										className={clsx(classes.signInButton)}>
										Save
									</Button>
								</Box>
							</Form>
						)}
						</Formik>
					</Box>
				</Paper>
			</Grid>
		</Grid>
	</Box>
  );
};

export default AddSubCategory;
